export function ResignationIllustration() {
  return (
    <svg
      width="292"
      height="200"
      viewBox="0 0 292 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-auto w-full max-w-[292px]"
    >
      {/* Floor */}
      <rect y="170" width="292" height="30" fill="#1a1d27" />
      <line x1="0" y1="170" x2="292" y2="170" stroke="#2a2d3e" strokeWidth="1" />

      {/* Window back */}
      <rect x="20" y="20" width="80" height="60" rx="2" fill="#2a2d3e" />
      <rect x="24" y="24" width="34" height="52" fill="#7c8cf8" fillOpacity="0.2" />
      <rect x="62" y="24" width="34" height="52" fill="#7c8cf8" fillOpacity="0.15" />

      {/* Plant */}
      <rect x="115" y="130" width="20" height="22" rx="2" fill="#5b6ce0" />
      <ellipse cx="125" cy="120" rx="14" ry="18" fill="#10b981" fillOpacity="0.6" />
      <ellipse cx="118" cy="115" rx="8" ry="12" fill="#10b981" fillOpacity="0.45" />
      <ellipse cx="132" cy="115" rx="8" ry="12" fill="#10b981" fillOpacity="0.5" />

      {/* Desk */}
      <rect x="155" y="125" width="120" height="6" rx="1" fill="#2a2d3e" />
      <rect x="160" y="131" width="4" height="40" fill="#2a2d3e" />
      <rect x="266" y="131" width="4" height="40" fill="#2a2d3e" />

      {/* Laptop */}
      <rect x="180" y="105" width="55" height="35" rx="2" fill="#0f1117" stroke="#7c8cf8" strokeWidth="1" />
      <rect x="184" y="109" width="47" height="27" fill="#7c8cf8" fillOpacity="0.25" />
      <rect x="178" y="138" width="59" height="3" rx="1" fill="#2a2d3e" />

      {/* Letter on desk */}
      <rect x="245" y="118" width="22" height="14" rx="1" fill="#f87272" fillOpacity="0.85" transform="rotate(-8 256 125)" />
      <line x1="248" y1="123" x2="262" y2="121" stroke="#0f1117" strokeOpacity="0.4" strokeWidth="0.8" transform="rotate(-8 256 125)" />
      <line x1="248" y1="126" x2="262" y2="124" stroke="#0f1117" strokeOpacity="0.4" strokeWidth="0.8" transform="rotate(-8 256 125)" />

      {/* Standing person 1 (left) */}
      <circle cx="60" cy="105" r="10" fill="#f5d0c5" />
      <path d="M50 117 L70 117 L73 160 L66 160 L64 130 L62 160 L55 160 Z" fill="#7c8cf8" />
      <rect x="52" y="160" width="6" height="10" fill="#2a2d3e" />
      <rect x="64" y="160" width="6" height="10" fill="#2a2d3e" />
      {/* Hair */}
      <path d="M50 100 Q60 88 70 100 L70 105 L50 105 Z" fill="#3b3f54" />

      {/* Sitting person at desk */}
      <circle cx="210" cy="92" r="9" fill="#e8b896" />
      <path d="M201 102 L219 102 L221 130 L199 130 Z" fill="#5b6ce0" />
      <path d="M195 88 Q210 76 225 88 L225 95 L195 95 Z" fill="#1a1d27" />
      {/* Chair */}
      <rect x="198" y="125" width="24" height="32" fill="#2a2d3e" />
      <rect x="208" y="157" width="4" height="13" fill="#2a2d3e" />

      {/* Standing person 2 (concerned, hand up) */}
      <circle cx="115" cy="98" r="10" fill="#d4a574" />
      <path d="M105 110 L125 110 L128 158 L121 158 L119 128 L117 158 L110 158 Z" fill="#f59e0b" fillOpacity="0.85" />
      <rect x="107" y="158" width="6" height="12" fill="#2a2d3e" />
      <rect x="119" y="158" width="6" height="12" fill="#2a2d3e" />
      <path d="M105 95 Q115 84 125 95 L125 100 L105 100 Z" fill="#5a3a2a" />
      {/* Raised arm */}
      <path d="M126 112 L138 96 L142 98 L130 116 Z" fill="#f59e0b" fillOpacity="0.85" />
      <circle cx="140" cy="96" r="3" fill="#d4a574" />

      {/* Speech indicator */}
      <circle cx="155" cy="60" r="3" fill="#7c8cf8" fillOpacity="0.7" />
      <circle cx="165" cy="55" r="2" fill="#7c8cf8" fillOpacity="0.5" />
      <circle cx="172" cy="48" r="1.5" fill="#7c8cf8" fillOpacity="0.4" />
    </svg>
  );
}